import React from 'react';
import { BrainIcon, HeartIcon, ClockIcon } from 'lucide-react';
export const ProblemStatementSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-846">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-6 border-l-4 border-[#d4af37] pl-4" data-id="element-847">
        De Uitdaging: Betrokkenheid bij Mentale Gezondheid
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-848">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-849">
          <div className="flex items-center mb-2" data-id="element-850">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm" data-id="element-851">
              <ClockIcon className="w-5 h-5 text-[#d4af37]" data-id="element-852" />
            </div>
            <h4 className="text-lg font-light text-[#333333]" data-id="element-853">
              Inconsistente Zelfzorg
            </h4>
          </div>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-854">
            Gebruikers starten enthousiast, maar hebben moeite om een
            consistente routine vol te houden, wat de effectiviteit vermindert.
          </p>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-855">
          <div className="flex items-center mb-2" data-id="element-856">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm" data-id="element-857">
              <BrainIcon className="w-5 h-5 text-[#d4af37]" data-id="element-858" />
            </div>
            <h4 className="text-lg font-light text-[#333333]" data-id="element-859">
              Complexe Thematiek
            </h4>
          </div>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-860">
            Mentale gezondheid omvat serieuze onderwerpen – traditionele
            gamification voelt ongepast en kinderachtig.
          </p>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-861">
          <div className="flex items-center mb-2" data-id="element-862">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm" data-id="element-863">
              <HeartIcon className="w-5 h-5 text-[#d4af37]" data-id="element-864" />
            </div>
            <h4 className="text-lg font-light text-[#333333]" data-id="element-865">
              Premium Doelgroep
            </h4>
          </div>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-866">
            Onze gebruikers verwachten een verfijnde ervaring die past bij
            Mosy's premium uitstraling – geen opdringerige elementen.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" data-id="element-867">
        <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-868">
          <h3 className="text-xl font-light text-[#333333] mb-2 flex items-center" data-id="element-869">
            <HeartIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-870" />
            De Mosy Ervaring
          </h3>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-871">
            Mosy biedt gespecialiseerde mentale gezondheidszorg via een high-end
            app. Onze engagement-strategie moet de serene, respectvolle ervaring
            versterken, niet verstoren.
          </p>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-872">
          <h3 className="text-xl font-light text-[#333333] mb-2 flex items-center" data-id="element-873">
            <BrainIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-874" />
            Onze Gebruikers & Thema's
          </h3>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-875">
            Gebruikers zoeken hulp bij burnout, stress, slaapproblemen,
            relaties, rouw en angst. Onze benadering moet deze serieuze thema's
            respectvol behandelen.
          </p>
        </div>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg max-w-3xl mx-auto" data-id="element-876">
        <p className="text-[#666666] italic text-center text-sm leading-relaxed" data-id="element-877">
          "Hoe motiveren we gebruikers om regelmatig in te checken en hun
          mentale gezondheidsroutine vol te houden, zonder afbreuk te doen aan
          de luxe, respectvolle ervaring die Mosy biedt?"
        </p>
      </div>
    </div>;
};